module.exports = __webpack_public_path__ + "img/IAA.c54a1f9f.svg";